import { Card, Typography } from "antd";
import {
  ContainerComponent,
  ImageWithFallback,
  RowComponent,
} from "../../../components";
import RenderMarkdown from "../../../components/render-markdown.component";
import { ShowUseCaseRoute } from "../views/show-use-case.view";
import { useState } from "react";
import { Link } from "react-router-dom";

export const UseCaseItemPartial = ({ ...props }) => {
  const [isHovering, setisHovering] = useState(false);

  return (
    <Link
      to={ShowUseCaseRoute({ usecaseId: props.id })}
      style={{ width: "100%" }}
    >
      <Card
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.03)";
          e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
          setisHovering(true);
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "none";
          setisHovering(false);
        }}
        style={{
          border: "1px solid #ccc",
          borderRadius: 16,
          padding: 0,
          cursor: "pointer",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflow: "hidden",
        }}
      >
        <ImageWithFallback
          src={
            props.imageUrl ||
            "https://devagentesinteligentes.blob.core.windows.net/agentes-catalogo/under_contruction.png"
          }
          alt="Imagen del caso de uso"
          onError={(e) => {
            e.target.onerror = null; // Evita loops infinitos si la URL de respaldo también falla
            e.target.src =
              "https://devagentesinteligentes.blob.core.windows.net/agentes-catalogo/under_contruction.png";
          }}
          style={{
            minWidth: "100%",
            height: "150px",
            objectFit: "cover",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            transform: isHovering ? "scale(1.05)" : "scale(1)",
            boxShadow: isHovering
              ? "0 4px 15px rgba(255, 255, 255, 0.1)"
              : "none",
          }}
        />
        <ContainerComponent
          style={{
            padding: 16,
            alignItems: "start",
            textAlign: "start",
            height: "200px",
          }}
        >
          <RowComponent
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Typography.Title
              level={4}
              ellipsis={{
                rows: 2, // Número de líneas antes de cortar
                expandable: false, // Evita que se expanda al hacer clic
              }}
              style={{
                marginBottom: 0,
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
              }}
            >
              {props.name}
            </Typography.Title>

            {/* <Tag color="blue">{"label"}</Tag> */}
          </RowComponent>
          {/* ESTRELLAS */}
          {/* <RowComponent style={{ alignItems: "center", marginBottom: 8 }}>
            <div style={{ marginRight: 8 }}>
              {[...Array(5)].map((_, i) => (
                <StarFilled
                  key={i}
                  style={{
                    color: i < 4 ? "#fadb14" : "#d9d9d9",
                    fontSize: 16,
                    marginRight: 2,
                  }}
                />
              ))}
            </div>
            <Typography.Text level={3}>(24)</Typography.Text>
          </RowComponent> */}
          <Typography.Paragraph
            ellipsis={{
              rows: 4, // Número de líneas antes de cortar
              expandable: false, // Evita que se expanda al hacer clic
            }}
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
          >
            {
              props.description ? (
                <RenderMarkdown markdownContent={props.description} />
              ) : ( 
                "Sin descripción"
              )
            }
            {/* {props.description || "Sin descripción"} */}
          </Typography.Paragraph>
        </ContainerComponent>

        <ContainerComponent style={{ padding: 16 }}>
          <RowComponent style={{ justifyContent: "end" }}>
            <Typography.Text level={3} style={{ textDecoration: "underline" }}>
              Ver caso de uso
            </Typography.Text>
          </RowComponent>
        </ContainerComponent>
      </Card>
    </Link>
  );
};
